<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exp"  ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			header-row-class-name="headerclass"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="WORKCENTER_CODE" :label="$t('getapi[3305]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="WORKCENTER_NAME" :label="$t('getapi[3306]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="QUEUE_TIME" :label="$t('getapi[3307]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="QUEUE_TIME_UNIT" :label="$t('getapi[3308]')"></el-table-column>
			<el-table-column prop="KEY_FLAG2" :label="$t('getapi[3309]')">
				<template scope="scope">
					<span>{{ scope.row.KEY_FLAG2 | lanchange}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="OUT_FLAG2" :label="$t('getapi[1271]')">
				<template scope="scope">
					<span>{{ scope.row.OUT_FLAG2 | lanchange}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="enable_flag2" :label="$t('getapi[552]')">
				<template slot-scope="scope">
					{{scope.row.enable_flag2 | lanchange}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="EFFECTIVE" :label="$t('getapi[3310]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="report_Measure_method2" :label="$t('getapi[3311]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Charge_rate" :label="$t('getapi[3312]')" align="right"></el-table-column>
			<el-table-column prop="manage_cost" :label="$t('getapi[3313]')" align="right">
				<template slot-scope="scope">
					{{scope.row.manage_cost | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="WORK_CALENDAR_CODE" :label="$t('getapi[3314]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="multiple_value" :label="$t('getapi[3315]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Shop_group_name" :label="$t('getapi[3316]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="std_value" :label="$t('getapi[6288]')"></el-table-column>
			<el-table-column fixed="right" :label="$t('getapi[6048]')" width="120">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
					<!-- <el-button @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button> -->
					<el-popconfirm
						:confirmButtonText="$t('getapi[6109]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="del(scope)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
						<!-- <el-button slot="reference" type="text" size="small"></el-button> -->
					</el-popconfirm>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="workcost_rate" :label="$t('getapi[12492]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="cargoposition_code" :label="$t('getapi[12578]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="leadtime" :label="$t('getapi[7215]')"></el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="ENGWORKCENTERViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 		<el-dialog :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%">
			<el-tabs type="border-card">
				<el-tab-pane :label="$t('getapi[2020]')">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
						<el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none" />
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog> -->
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[6861]')" width="33%" :close-on-click-modal="false">
			
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3305]')}}</td>
					<td><el-input v-model="formInline._workcenter_code" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[3306]')}}</td>
					<td><el-input v-model="formInline._workcenter_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3309]')}}</td>
					<td>
						<el-select filterable v-model="formInline._key_flag"  size="mini">
							<el-option :label="$t('getapi[2052]')" :value=true></el-option>
							<el-option :label="$t('getapi[2053]')" :value=false></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[3307]')}}</td>
					<td><el-input v-model="formInline._queue_time" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3308]')}}</td>
					<td>
						<el-select filterable v-model="formInline._queue_time_unit"  size="mini">
							<el-option :label="$t('getapi[1474]')" :value="0"></el-option>
							<el-option :label="$t('getapi[1475]')" :value="1"></el-option>
							<el-option :label="$t('getapi[1476]')" :value="2"></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[4563]')}}</td>
					<td>
						<el-select filterable v-model="formInline._out_flag"  size="mini">
							<el-option :label="$t('getapi[561]')" :value="true"></el-option>
							<el-option :label="$t('getapi[866]')" :value="false"></el-option>
						</el-select>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[552]')}}</td>
					<td>
						<el-select filterable v-model="formInline._enable_flag"  size="mini">
							<el-option :label="$t('getapi[1170]')" :value="true"></el-option>
							<el-option :label="$t('getapi[1171]')" :value="false"></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[3310]')}}</td>
					<td><el-input v-model="formInline._effective" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3311]')}}</td>
					<td>
						<el-select filterable v-model="formInline._report_measure_method" @change="ChageWorkcost_rate()" size="mini">
							<el-option :label="$t('getapi[76]')" :value="0"></el-option>
							<el-option :label="$t('getapi[880]')" :value="1"></el-option>
							<el-option :label="$t('getapi[139]')" :value="2"></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[3312]')}}</td>
					<td><el-input v-model="formInline._charge_rate" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[12492]')}}</td>
					<td><el-input v-model="formInline._workcost_rate" :disabled="!workcostrateEdit" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3313]')}}</td>
					<td><el-input v-model="formInline._manage_cost" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
					<td>{{$t('getapi[3314]')}}</td>
					<td>
						<routejump :urlNo="44" :isDialog="1" @callback="beforeRoutJump">
						<el-select v-model="formInline._work_calendar_code">
							<el-option v-for="items in CalendarDropDown" :key="items.Cd_Code" :label="items.Cd_Code" :value="items.Cd_Code"></el-option>
						</el-select>
						</routejump>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[3315]')}}</td>
					<td><el-input v-model="formInline._multiple_value" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
					<td>{{$t('getapi[3316]')}}</td>
					<td>
						<routejump :urlNo="48" :isDialog="1" @callback="beforeRoutJump">
						<el-select filterable v-model="formInline._shop_group_name"  size="mini">
							<el-option
								v-for="items in ShopGroupList"
								:key="items.Name"
								:label="items.Name"
								:value="items.Name"
							></el-option>
						</el-select>
						</routejump>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[6288]')}}</td>
					<td><el-input v-model="formInline._std_value" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
					<td>{{$t('getapi[12578]')}}</td>
                    <td>
						<routejump :urlNo="42" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="formInline._cargoposition_code"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCargo()"></i>
                        </el-input>
						</routejump>
                    </td>
				</tr>
				<tr>
					<td>{{$t('getapi[7215]')}}</td>
					<td><el-input v-model="formInline._leadtime" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
		<selector :isVisible="isVisiblecargo" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/General/GetWCenterCargoPositionPopupList'" @callback="getCargo"
                  ref="cargo"></selector>
	</div>
</template>

<script>
import Common from '@/components/Common';
import urlpost from '@/api/config.js';
export default {
	name: 'wcenter',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				_exclusively_id: 0,
				_workcenter_code: '',
				_workcenter_name: '',
				_queue_time: 0,
				_queue_time_unit: '',
				_key_flag: true,
				_out_flag: true,
				_enable_flag: true,
				_effective: 0,
				_create_person: '',
				_create_time: '',
				_modify_person: '',
				_modify_time: '',
				_work_calendar_code: '',
				_remark: '',
				_multiple_value: 0,
				_manage_cost: 0,
				_charge_rate: 0,
				_report_measure_method: 0,
				_shop_group_name: '',
				_workshop_section: '',
				_workcost_rate:1
			},
			oldFormInline:[],
			ids: '',
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('wcenter'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: '', // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true, // 是否新增
			CalendarDropDown: [],
			ShopGroupList: [],
			CargoPositionList: [],
			btn: {
				del: false,
				edit: false
			},
			workcostrateEdit:false,
			isVisiblecargo:false,
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
		that.getqwlist();
		urlpost.urlpost('Basic/GetShopGroupList', {}, function(res) {
			console.log(res);
			if (res.Success == 1) {
				that.ShopGroupList = res.DataContent;
			}
		});
		urlpost.urlpost('Basic/WH/GetCalendarDropDown', {}, function(res) {
			console.log(res);
			if (res.Success == 1) {
				that.CalendarDropDown = res.DataContent;
			}
		});

	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3083]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (ilimits) {
				case 2:
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
					break;
				case 3:
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
					break;
				default:
					that.$refs.SetBtn.SetButtonEnable('');
					break;
			}
		},
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.intidata();
			this.authority();
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('wcenter',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
			that.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			console.log(parm);
			that.$http.urlpost('Basic/Items/WorkCenterDataList', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		selectCargo() {
                let that = this;
				that.isVisiblecargo=true;
                that.$refs.cargo.clearInput(true);
        },
		getCargo(data) {
			let that = this
			that.formInline._cargoposition_code = data.cargoposition_code
                 
        },
		// 保存数据
		sava() {
			let that = this;
			that.loading = true;
			let parm ={
				model:that.formInline,
				LangType:that.$processdata.getLang()
			}
			
			console.log(parm);
			that.$http.urlpost('Basic/Items/SaveEngWorkCenter', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
					that.intidata();
                    that.editvisi = false;
				}
			});
            that.loading = false;
		},
		// 获取查询条件
		getqwlist() {
			let that = this;
			that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
				that.queryData = res.DataContent;
			});
		},
		// 编辑
		edit(jsd) {
		    let that = this;
			this.editvisi = true;
			this.formInline = {
				_exclusively_id: jsd.row.Exclusively_Id,
				_workcenter_code: jsd.row.WORKCENTER_CODE,
				_workcenter_name: jsd.row.WORKCENTER_NAME,
				_queue_time: jsd.row.QUEUE_TIME,
				_queue_time_unit: jsd.row.QUEUE_TIME_UNIT,
				_key_flag: jsd.row.KEY_FLAG,
				_out_flag: jsd.row.OUT_FLAG,
				_enable_flag: jsd.row.enable_flag,
				_effective: jsd.row.EFFECTIVE,
				_work_calendar_code: jsd.row.WORK_CALENDAR_CODE,
				_multiple_value: jsd.row.multiple_value,
				_manage_cost: jsd.row.manage_cost,
				_charge_rate: jsd.row.Charge_rate,
				_report_measure_method: jsd.row.report_Measure_method,
				_shop_group_name: jsd.row.Shop_group_name,
				_std_value:jsd.row.std_value,
				_workcost_rate:jsd.row.workcost_rate,
				_cargoposition_code:jsd.row.cargoposition_code,
                _leadtime:jsd.row.leadtime,
			};
			that.oldFormInline = JSON.stringify(that.formInline)
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		ChageWorkcost_rate(){
			let that=this;
			if(that.formInline._report_measure_method==0){
				that.formInline._workcost_rate=1;
				that.workcostrateEdit=false;
			}
			else{
				that.workcostrateEdit=true;
			}
			
			if(that.formInline._workcost_rate==0){
				that.formInline._workcost_rate==1;
			}
			
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('Basic/Items/BatchDeleteWorkCenter', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));
					that.datajson.forEach(function(item, index) {
						if (that.ids.indexOf(item.Exclusively_Id) >= 0) {
							that.datajson.splice(index, 1);
						}
					});
				}
			});
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.Exclusively_Id + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			this.formInline = {
				_exclusively_id: 0,
				_workcenter_code: '',
				_workcenter_name: '',
				_queue_time: 0,
				_queue_time_unit: 1,
				_key_flag: false,
				_out_flag: false,
				_enable_flag: true,
				_effective: 0,
				_create_person: '',
				_create_time: '',
				_modify_person: '',
				_modify_time: '',
				_work_calendar_code: '',
				_remark: '',
				_multiple_value: 0,
				_manage_cost: 0,
				_charge_rate: 0,
				_report_measure_method: 0,
				_shop_group_name: '',
				_workshop_section: '',
                _std_value:0,
				_workcost_rate:1,
				_cargoposition_code:'',
				_leadtime:0,
			};
			this.editvisi = true;
		},
		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'ENGWORKCENTERViewInfo');
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		//导出·
		exp() {
			let that = this;
			that.loading = true;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: [],
                LangType:that.$processdata.getLang(),
                fromname: that.$t('getapi[585]')
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			console.log(parm);
			that.$http.urlpost('Basic/Items/WorkCenter_ExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
        beforeRoutJump(val,callback){
            let that = this
            if(that.oldFormInline != JSON.stringify(that.formInline)){
                this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.editvisi = false
                        callback(true)
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            } else {
                that.editvisi = false
                callback(true)
            }
        }
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
